<template>
  <div class="pages">
    <!-- 车辆属性信息 -->
    <car-attribute-list ref="carAttributeList" :carAttributeFeeConfig="carAttributeFeeConfig" style="margin-bottom: 40px;" :car-type-id.sync="carTypeId" :listCurrent.sync="listCurrent" :childrenCurrent.sync="childrenCurrent"/>
    <!-- 现在用车订单取消规则 -->
    <current-order :carAttributeFeeConfig="currentCarAttributeFeeConfig"/>
    <!-- 预约订单取消规则 -->
    <reservation-order :carAttributeFeeConfig="currentCarAttributeFeeConfig" />
    <!-- 预览图片 -->
    <image-preview ref="imagePreview" />
    <car-attribute-details-popup ref="carAttributeDetailsPopup" />
  </div>
</template>

<script>
import { Toast } from "vant";
import { getAutoCarAttributeFeeConfig } from "@/api/beecargo/autoCarFeeRules/index.js";
import carAttributeList from "@/view/beecargo/cancelAutoCarOrderRules/components/car-attribute-list.vue";
import currentOrder from "@/view/beecargo/cancelAutoCarOrderRules/components/current-order.vue";
import reservationOrder from "@/view/beecargo/cancelAutoCarOrderRules/components/reservation-order.vue";
import imagePreview from "@/view/beecargo/cancelAutoCarOrderRules/components/image-preview.vue";
import carAttributeDetailsPopup from "@/view/beecargo/cancelAutoCarOrderRules/components/car-attribute-details-popup.vue";
export default {
  components:{ 
    carAttributeList ,
    currentOrder,
    reservationOrder,
    imagePreview ,
    carAttributeDetailsPopup ,
    [Toast.name]:Toast
  },
  data(){
    return {
      carTypeId:null,
      carAttributeFeeConfig:{appointmentOrderCancelTransportOrderRule:{},fastOrderCancelTransportOrderRule:{}},
      listCurrent:0,
      childrenCurrent:0
    }
  },
  computed:{
    currentCarAttributeFeeConfig(){
      return this.carAttributeFeeConfig[this.listCurrent].children[this.childrenCurrent].feeConfig;
    }
  },
  provide(){
    return {
      imagePreview: options => this.$refs["imagePreview"].show(options),
      carAttributeDetailsPopup : options => this.$refs["carAttributeDetailsPopup"].show(options)
    }
  },
  created(){
    this.getCarAttributeFeeConfig();
  },
  methods:{
    getCarAttributeFeeConfig(){
      this.$toast({
        type:"loading",
        forbidClick:true,
        duration:0,
        message:"加载中"
      });
      return getAutoCarAttributeFeeConfig().then(({ data }) => {
        if(!data) return false;
        // 过滤掉没有子元素的项
				data = data && data.filter(item => 
				  item.children && item.children.length > 0
				);
        this.carAttributeFeeConfig = data;
      }).finally(()=>Toast.clear())
    }
  }
}
</script>

<style scoped lang="scss">
  .pages {
    background-color: #FFF;
    padding-bottom: 46px;
  }
  ::v-deep .component {
    padding: 0 12px;
    .component-title {
      font-size: 16px;
      color: #EC892E;
      line-height: 32px;
      padding-left: 7px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 8px;
        top: 8px;
        z-index: 1;
        width: 3px;
        border-radius: 1px;
        background-color: #EC892E;
      }
    }
    .flex-sb {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
</style>